(function() {
'use strict';

angular
    .module('TR')
    .service('actionTemplateService', actionTemplateService);

function actionTemplateService(dateUtil, $http, $rootScope, resourceService) {
    const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const actionUtils = {
        PAYBALANCE: {
            format: String.format,
            addDays: (function() {
                const today = new Date();
                return function(days) {
                    return dateUtil
                            .addDays(today, days)
                            .toDateString();
                };
            })()
        },
        VOUCHERACTIONS: {
            sendConfirmationEmail: (function() {
                const cultureCode = TRPCONFIG.Domain.CultureCode;

                return function(emails, bookingId) {
                    const emailsArray = emails.split(',');
                    for (let i = emailsArray.length - 1; i >= 0; i--) {
                        const email = emailsArray[i].trim();
                        if (!validEmail.test(email)) {
                            $rootScope.$broadcast('flash:error', String.format(resourceService.get('VOUCHERINVALID'), email));
                            return;
                        }
                    }

                    $http.post('/api2/managebooking/sendconfirmationemail',
                        { BookingId: bookingId, Culture: cultureCode, Emails: emailsArray });
                    $rootScope.$broadcast('flash:success', resourceService.get('VOUCHERSENT'));
                };
            })()
        }
    };

    const service = {
        getUtils(name) { return actionUtils[name]; }
    };

    return service;
}
})();
